import React, { Component } from 'react';

export class NotFound extends Component {
    render() {
        return (
            <div>
                <h1>404 - Página não encontrada</h1>
                <div className="row">
                    <div className="col-sm-12">
                        <span>Não há nada para ver aqui, escolha o seu destino no menu de navegação.</span>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NotFound.js